import { h, render } from 'preact';

import(/* webpackChunkName: "analytics" */ '@data-visuals/analytics').then(
  analytics => analytics.init()
);

const ribbonContainer = document.getElementById('ribbon-container');

if (ribbonContainer) {
  import(/* webpackChunkName: "Ribbon" */ './components/Ribbon').then(
    ({ default: Ribbon }) => render(<Ribbon />, ribbonContainer)
  );
}

import(/* webpackChunkName: "ads" */ './utils/ad-loader').then(
  ({ default: AdLoader }) => {
    const ads = new AdLoader();
    ads.init();
  }
);



// WEBPACK FOOTER //
// ./kickstart.js